import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuthCookie, removeAuthCookie } from "../../utils/cookie";

// Get Profile
export const getProfile = createAsyncThunk(
  "profile/getProfile",
  async (_, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) {
        throw new Error("No token found");
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/profile`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to load profile" },
      );
    }
  },
);
// edit profile
export const editProfile = createAsyncThunk(
  "profile/editProfile",
  async (payload, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) {
        throw new Error("No token found");
      }

      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/profile`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to update profile" },
      );
    }
  },
);
// verify-email-change

export const verifyEmailChange = createAsyncThunk(
  "profile/verifyEmailChange",
  async (otp, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/verify-email-change`,
        { otp },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to verify OTP" },
      );
    }
  },
);

// Profile slice
const profileSlice = createSlice({
  name: "profile",
  initialState: {
    profileData: null,
    loading: false,
    error: null,
    isAuthenticated: false,
  },
  reducers: {
    clearProfileState: (state) => {
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchProfile
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profileData = action.payload?.data || action.payload;
        state.isAuthenticated = true;
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to load profile";
        state.isAuthenticated = false;
        removeAuthCookie();
      })
      // edit profile
      .addCase(editProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profileData = {
          ...state.profileData,
          ...action.payload?.data,
        };
      })
      .addCase(editProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to update profile";
      })
      // verify-email-change
      .addCase(verifyEmailChange.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyEmailChange.fulfilled, (state, action) => {
        state.loading = false;
        state.profileData = action.payload?.data || state.profileData;
      })
      .addCase(verifyEmailChange.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to verify OTP";
      });
  },
});

export const { clearProfileState } = profileSlice.actions;
export default profileSlice.reducer;
